const STORAGE_KEY = "brian.outbound.line";

/** Per device, not per clinic: the desk phone next to this screen is this screen's business. */
export const readPreferredLine = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const writePreferredLine = (endpointUuid: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, endpointUuid);
  } catch {
    // Storage refused (private mode, quota): the picker just asks again.
  }
};
